import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import Vuex from 'vuex';
import router from './router';
import axios from 'axios';
import UtiltyJS from './js/UtilityFunction.js';
import createPersistedState from "vuex-persistedstate";
import  './assets/css/reset.css'
import Print from './plugins/print';
// import ElementUI from 'element-ui';
// import { ElementTiptapPlugin } from 'element-tiptap';
//
// import 'element-ui/lib/theme-chalk/index.css';
//
// import 'element-tiptap/lib/index.css';
// //vue-quill-editor
// import VueQuillEditor from 'vue-quill-editor'
// // require styles
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
//
// Vue.use(VueQuillEditor)
//
// // use ElementUI's plugin
// Vue.use(ElementUI);
// // use this package's plugin
// Vue.use(ElementTiptapPlugin, { lang: "zh_tw" });
// // Now you register `'el-tiptap'` component globally.

//------ 載入環境設定的設定檔 -------- read from setting.json
import appSetting from '../static/conf/setting.json';


// import './assets/css/commons.css'
// import './assets/css/daan.css'
// import './assets/css/ksph3.css'
// import './assets/css/ksph.css'
 import './assets/css/gaodamei.css' //高大美杏生醫院
// import './assets/css/gdm.css' //高大美杏生醫院
// import './assets/css/tan.css'
// import './assets/css/tanc.css'
// import './assets/css/zxiao.css'
// import './assets/css/borji.css'
// import './assets/css/broz.css'
// import './assets/css/lgsi.css' //劉光雄
// import './assets/css/tand.css' //芯莊園診所
// import './assets/css/shs.css' //博愛蕙馨
// import './assets/css/chungjen.css' //s重仁骨科
// import './assets/css/kanan.css' //安安十全
// import './assets/css/siho.css' //杏和
// import './assets/css/yhanan.css' //永華安安 婦產科
// import './assets/css/yhananc.css' //永華安安 小兒科
// import './assets/css/ja.css' //健愛婦幼診所
// import './assets/css/jns.css' //新正薪
//import './assets/css/weihao.css' //為好
// import './assets/css/sjh.css' //溪州



console.log("appSetting appSetting.baseUrl = " + appSetting.baseUrl);
//============= 處理 baseUrl ------ 注意 Local Port number =========
let sUrl="";
let fUrl="";
if (location.host == "localhost:8085") {
  sUrl = appSetting.localTestUrl + ":" + appSetting.localTestPort;
  fUrl = appSetting.localTestUrl + ":" + appSetting.fileSrvPort;
} else {
  //location.host
  sUrl = location.protocol + "//" + location.hostname + ":" + location.port;
  fUrl = location.protocol + "//" + location.hostname + ":" + appSetting.fileSrvPort;
}

console.log("sUrl=" + sUrl);
console.log("fUrl=" + fUrl);


appSetting.baseUrl = appSetting.baseUrl.replace(/_ServerIp/g, sUrl);
console.log("appSetting.baseUrl=" + appSetting.baseUrl);

appSetting.backSrvUrl = appSetting.backSrvUrl.replace(/_baseUrl/g, appSetting.baseUrl);

console.log("appSetting.backSrvUrl=" + appSetting.backSrvUrl);

//appSetting.iKnowSrvUrl = appSetting.iKnowSrvUrl.replace(/_baseUrl/, appSetting.baseUrl);
appSetting.iFormViewerUrl = appSetting.iFormViewerUrl.replace(/_baseUrl/, appSetting.baseUrl);
appSetting.iFormSrvUrl = appSetting.iFormSrvUrl.replace(/_baseUrl/, appSetting.baseUrl);
// appSetting.iDsSrvUrl = appSetting.iDsSrvUrl.replace(/_baseUrl/, appSetting.baseUrl);

appSetting.hisSrvUrl = appSetting.hisSrvUrl.replace(/_baseUrl/, appSetting.baseUrl);

appSetting.fileSrvUrl = appSetting.fileSrvUrl.replace(/_baseUrl/, fUrl);
console.log("appSetting.fileSrvUrl=" + appSetting.fileSrvUrl);
console.log(appSetting.fileSrvUrl);
//------------------------
console.log("appSetting appSetting.iFormViewerUrl = " + appSetting.iFormViewerUrl);
console.log("appSetting appSetting.versionFront= " + appSetting.versionFront);

//===========================================================
axios.interceptors.response.use((response) => {
  //console.info("->1 攔截結果 : " + response.data.status.toString());
  switch (response.data.status.toString()) {
    case 'INFO':
      //console.info("攔截結果 : IS OK");
      break;
    case 'WARN':
      break;
    case 'ERROR':
      console.error("攔截結果 : is Error ");
      break;
    case 'FATAL':
      break;
    case 'UNAUTH':
      console.error("攔截結果 : 需要授權");
      router.push('/');
      break;
    case '404':
      console.warn("攔截結果 : 伺服器未找到目標網址，URL不存在");
      break;
    case '500':
    case '503':
      console.log("攔截結果 : 伺服器發生錯誤，可能未啟動或有問題....");
      break;
    default:
      console.error("攔截結果非為預期 : " + response.data.status);
  }

  return response;
});
//--------------------------------
axios.defaults.baseURL = appSetting.baseUrl;
Vue.use(Vuex);
Vue.use(Print);



//前端測試請使用 '/iNursingSrv' WebService
Vue.prototype.$http = axios;
Vue.prototype.$UtilityJs = UtiltyJS;
Vue.prototype.$EventBus = new Vue();

const store = new Vuex.Store({
  plugins:[createPersistedState()],
  state:{
    loginWebUser:{
      userId:'',
      loginTime:'',
    },
    patientInfo:{
      chartNo:'',
      ptName:'',
      bedNo:'',
      sex:'',
      serno:'',
      admitDays:'',
      ckinDate:'',
      birthDate:'',
      ckinTime:'',
      age:'',
      diagnosisF:'',
      pictContent:''
    },
    SystemControl: {
      AppHome_patientListStatus: true,
      AppHome_webCamStatus: false,
      AppHome_snackbar: {
        status: false,
        text: '',
        timeout: 4000,
        closeText: ''
      },
    },
    //--- 設定預設值, 也為了 coding 方便 ---
    AppSetting:{
      versionFront:'',
      baseUrl:'',
      localTestUrl:'',
      backSrvUrl:'',
      iFormViewerUrl:'',
      iFormSrvUrl:'',
      hisSrvUrl:'',
      hospId:'',
      systemId:'',
      zone:'',
      regClerk:''
},
    menuInfo:{
      funTitle: '',
      funUrl: '',
      parentId: '',
      securityType: '',
    },
    funList:[],
      patGroup:{
        group:0
      },
      zoneInfo:{
          hospId: "",
          hospName1: "",
          hospName2: "",
          hospNo: "",
          sid: ""
      }

  },
  mutations : {
    loginProc(state, user) {
      state.loginWebUser = user;
      // state.loginUser.loginDateTime = '';
    },
    logoutProc(state){
      state.loginUser = '';
    },
    selectPt(state, patientObj){
      state.patientInfo = patientObj;
    },
    clearPt(state) {
      state.patientInfo = '';
    },
    togglePtList(state){
      state.SystemControl.AppHome_patientListStatus = !state.SystemControl.AppHome_patientListStatus;
    },
    disablePtList(state){
      state.SystemControl.AppHome_patientListStatus = false;
    },
    toggleWebCam(state){
      state.SystemControl.AppHome_webCamStatus = !state.SystemControl.AppHome_webCamStatus;
    },
    setSnackBar(state,obj){
      state.SystemControl.AppHome_snackbar = obj;
    },
    setPtPic(state,src){
      state.patientInfo.pictContent = src;
    },
    setAppSetting(state, src){
      state.AppSetting = src;
    },
    setHospitalId(state, src){ //設定醫院代號
      state.AppSetting.hospId = src;
    },
    setMenuInfo(state, menu){
      state.menuInfo = menu;
    },
    clearMenuInfo(state){
      state.menuInfo = '';
     },
    setFunList(state, funList){
      state.funList = funList;
    },
    setZoneInfo(state, zoneInfo){
      state.zoneInfo = zoneInfo;
    },
    setPatGroup(state, patGroup){
      state.patGroup = patGroup;
    },
    setZone(state, src){ //設定院區
       state.AppSetting.zone = src;
      },
    setRegClerk(state,src){
        state.AppSetting.regClerk = src
    }
  }
});

//--- 儲存 setting.json 到 $store.state.AppSetting ------
store.commit('setAppSetting', appSetting);



Vue.config.productionTip = false
new Vue({
  vuetify,
  router,
  store,
  Print,
  render: h => h(App)
}).$mount('#app')